import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type FormCCOtp from "@/interface/FormCCOtp";
import { ref, type Ref } from "vue";

export default function supplementaryCardDetailsSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page9Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  otp: Ref<FormCCOtp>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page9Overlay.value = true;
  const requestModel = {
    principalFormId: ccFormValue.value.webFormRequestId,
    webFormRequestId: ccFormValue.value.supplementary.webFormRequestId,
    webFormDetail: {
      title: ccFormValue.value.supplementary.title,
      fullName: ccFormValue.value.supplementary.fullName,
      nameOnCard: ccFormValue.value.supplementary.nameOnCard,
      relationship: ccFormValue.value.supplementary.relationship,
      nationalityCode: ccFormValue.value.supplementary.nationality,
      dateOfBirth: ccFormValue.value.supplementary.dob,
      idTypeCode: ccFormValue.value.supplementary.idType,
      idNo: ccFormValue.value.supplementary.idNo,
      genderCode: ccFormValue.value.supplementary.gender,
      raceCode: ccFormValue.value.supplementary.race,
      otherRace: ccFormValue.value.supplementary.otherRace,
      motherMaidenName: ccFormValue.value.supplementary.motherMaidenName,
      emailAddress: ccFormValue.value.supplementary.email,
      mobileNo: ccFormValue.value.supplementary.mobileNo,
      mobileNoCountryCode:
        ccFormValue.value.supplementary.mobileNo != ""
          ? ccFormValue.value.supplementary.mobileCountryCode
          : "",
      residentialAddress: {
        addressLine1: ccFormValue.value.supplementary.residentialAddress1,
        addressLine2: ccFormValue.value.supplementary.residentialAddress2,
        addressLine3: ccFormValue.value.supplementary.residentialAddress3,
        postcode: ccFormValue.value.supplementary.postCode,
        city: ccFormValue.value.supplementary.city,
        state: ccFormValue.value.supplementary.state,
      },
    },
  };

  const suppEditValidate = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    suppFormId: ccFormValue.value.supplementary.webFormRequestId,
    isSupp: ccFormValue.value.supplementary.question1,
    supplementaryInformation: {
      title: ccFormValue.value.supplementary.title,
      fullName: ccFormValue.value.supplementary.fullName,
      nameOnCard: ccFormValue.value.supplementary.nameOnCard,
      relationship: ccFormValue.value.supplementary.relationship,
      nationalityCode: ccFormValue.value.supplementary.nationality,
      dateOfBirth: ccFormValue.value.supplementary.dob,
      idTypeCode: ccFormValue.value.supplementary.idType,
      idNo: ccFormValue.value.supplementary.idNo,
      genderCode: ccFormValue.value.supplementary.gender,
      raceCode: ccFormValue.value.supplementary.race,
      otherRace: ccFormValue.value.supplementary.otherRace,
      motherMaidenName: ccFormValue.value.supplementary.motherMaidenName,
      emailAddress: ccFormValue.value.supplementary.email,
      mobileNo: ccFormValue.value.supplementary.mobileNo,
      mobileNoCountryCode:
        ccFormValue.value.supplementary.mobileNo != ""
          ? ccFormValue.value.supplementary.mobileCountryCode
          : "",
      residentialAddress: {
        addressLine1: ccFormValue.value.supplementary.residentialAddress1,
        addressLine2: ccFormValue.value.supplementary.residentialAddress2,
        addressLine3: ccFormValue.value.supplementary.residentialAddress3,
        postcode: ccFormValue.value.supplementary.postCode,
        city: ccFormValue.value.supplementary.city,
        state: ccFormValue.value.supplementary.state,
      },
    },
  };

  const requestModel2 = {
    dropOffStep: "S10",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      supp: {
        isSupp: ccFormValue.value.supplementary.question1,
      },
    },
  };

  if (ccFormValue.value.summarySetting.supplementaryCardDetailsJump == true) {
    // MasterService.editSupplementaryValidate(suppEditValidate).then((res) => {
    MasterService.editSupplementaryValidate(
      suppEditValidate,
      ccFormValue.value.token
    )
      .then((res) => {
        if (res.status == 200) {
          ccFormValue.value.dropOffStep = 7;
          if (res.data.response == "Exist") {
            if (otp.value.supplementaryOtp.status != "verified") {
              ccFormValue.value.summarySetting.supplementaryCardDetailsJump =
                true;
              jumpStep(10, "", "9");
            } else {
              ccFormValue.value.summarySetting.supplementaryCardDetailsJump =
                false;
              jumpStep(12, "", "6");
            }
            page9Overlay.value = false;
          } else {
            if (ccFormValue.value.supplementary.question1 == "Yes") {
              MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
                .then((res) => {
                  if (res.status == 200) {
                    MasterService.suppCardSubmit(
                      requestModel,
                      ccFormValue.value.token
                    )
                      .then((res) => {
                        if (res.status == 200) {
                          page9Overlay.value = false;
                          ccFormValue.value.supplementary.webFormRequestId =
                            res.data.responseModel.subWebFormId;
                          ccFormValue.value.dropOffStep = 9;
                          ccFormValue.value.summarySetting.supplementaryUploadFileJump =
                            true;
                          if (otp.value.supplementaryOtp.status != "verified") {
                            ccFormValue.value.summarySetting.supplementaryCardDetailsJump =
                              true;
                            jumpStep(10, "", "9");
                          } else {
                            jumpStep(11, "", "9");
                          }
                        } else {
                          page9Overlay.value = false;
                        }
                      })
                      .catch((e) => {
                        if (e.response && e.response.data.code == "WB-401") {
                          // EndSession
                          page9Overlay.value = false;
                          isTimeOut.value = false;
                          isSessionEnd.value = true;
                        }
                      });
                  }
                })
                .catch((e) => {
                  if (e.response && e.response.data.code == "WB-401") {
                    // EndSession
                    page9Overlay.value = false;
                    isTimeOut.value = false;
                    isSessionEnd.value = true;
                  }
                });
            } else {
              const requestModel2 = {
                dropOffStep: "S10",
                webFormRequestId: ccFormValue.value.webFormRequestId,
                cardId: prop.cardId,
                icNumber: ccFormValue.value.basicInformation.idNo,
                webFormDetails: {
                  supp: {
                    isSupp: ccFormValue.value.supplementary.question1,
                  },
                },
              };
              MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
                .then((res) => {
                  if (res.status == 200) {
                    ccFormValue.value.dropOffStep = 9;
                    jumpStep(12, "", "9");
                    page9Overlay.value = false;
                  } else {
                    page9Overlay.value = false;
                  }
                })
                .catch((e) => {
                  if (e.response && e.response.data.code == "WB-401") {
                    // EndSession
                    page9Overlay.value = false;
                    isTimeOut.value = false;
                    isSessionEnd.value = true;
                  }
                });
            }
          }
        } else {
          page9Overlay.value = false;
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          page9Overlay.value = false;
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
      });
  } else {
    if (ccFormValue.value.supplementary.question1 == "Yes") {
      MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
        .then((res) => {
          if (res.status == 200) {
            MasterService.suppCardSubmit(requestModel, ccFormValue.value.token)
              .then((res) => {
                if (res.status == 200) {
                  page9Overlay.value = false;
                  ccFormValue.value.supplementary.webFormRequestId =
                    res.data.responseModel.subWebFormId;
                  ccFormValue.value.dropOffStep = 9;
                  if (otp.value.supplementaryOtp.success) {
                    jumpStep(11, "", "9");
                  } else {
                    jumpStep(10, "", "9");
                  }
                } else {
                  page9Overlay.value = false;
                }
              })
              .catch((e) => {
                if (e.response && e.response.data.code == "WB-401") {
                  // EndSession
                  page9Overlay.value = false;
                  isTimeOut.value = false;
                  isSessionEnd.value = true;
                }
              });
          }
        })
        .catch((e) => {
          if (e.response && e.response.data.code == "WB-401") {
            // EndSession
            page9Overlay.value = false;
            isTimeOut.value = false;
            isSessionEnd.value = true;
          }
        });
    } else {
      const requestModel2 = {
        dropOffStep: "S10",
        webFormRequestId: ccFormValue.value.webFormRequestId,
        cardId: prop.cardId,
        icNumber: ccFormValue.value.basicInformation.idNo,
        webFormDetails: {
          supp: {
            isSupp: ccFormValue.value.supplementary.question1,
          },
        },
      };
      MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
        .then((res) => {
          if (res.status == 200) {
            ccFormValue.value.summarySetting.supplementaryCardDetailsJump =
              false;
            ccFormValue.value.summarySetting.supplementaryUploadFileJump =
              false;
            ccFormValue.value.dropOffStep = 9;
            jumpStep(12, "", "9");
            page9Overlay.value = false;
          } else {
            page9Overlay.value = false;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data.code == "WB-401") {
            // EndSession
            page9Overlay.value = false;
            isTimeOut.value = false;
            isSessionEnd.value = true;
          }
        });
    }
  }
}
